import React from "react";
import { AUTH0_NEEDS_DOMAIN } from "./config";

/** Explains why Auth0 is hidden when Client ID is set but domain is missing. */
export default function Auth0SetupHint() {
  if (!AUTH0_NEEDS_DOMAIN) {
    return null;
  }
  return (
    <p
      style={{
        marginTop: "12px",
        fontSize: "13px",
        color: "#555",
        lineHeight: 1.4,
      }}
    >
      <strong>Auth0 sign-in is off:</strong> add{" "}
      <code style={{ fontSize: "12px" }}>REACT_APP_AUTH0_DOMAIN</code> to{" "}
      <code style={{ fontSize: "12px" }}>.env</code> (value from Auth0 Dashboard →
      Settings → General → <em>Domain</em>, e.g.{" "}
      <code style={{ fontSize: "12px" }}>dev-xxxxx.us.auth0.com</code>), then restart{" "}
      <code style={{ fontSize: "12px" }}>npm start</code>.
    </p>
  );
}
